<template>
  <svg
    width="104"
    height="52"
    viewBox="0 0 104 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 26C3 26 10.2593 49 27.5 49C44.7407 49 52 26 52 26C52 26 59.2593 3.00028 76.5 3C93.7407 2.99972 101 26 101 26"
      stroke-width="5"
    />
  </svg>
</template>
